/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react'
import classNames from 'classnames'
import styles from './Text.module.scss'

const Text = ({
  children = undefined,
  color = 'blackColor',
  fontSize = 'small',
  style = {},
  bold = false,
  className = '',
  id = '',
  title = null,
  alignCenter = false,
  onClick = () => null,
}) => {
  return (
    <p
      id={id}
      title={title}
      className={classNames(
        styles.text,
        styles[color],
        styles[`font-${fontSize}`],
        className,
        { [styles.bold]: bold, [styles.textCenter]: alignCenter }
      )}
      style={style}
      onClick={onClick}
    >
      {children}
    </p>
  )
}

export default React.memo(Text)
